<template>
  <div class="main">
    <div class="pic" v-if="pic"><img :src="pic" :alt="title"></div>

    <div class="title">
      <div>
        <h1 v-html="title"></h1>
        <p v-html="eng"></p>
      </div>
    </div>
    <div class="bread">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main{
  position: relative;
  width: 100%;
  z-index: 10;
}
.pic{
  position: relative;
  padding: calc(100% / 16 * 5.2) 0 0;
  border-radius: 0 0 0 1vw;
  overflow: hidden;
  min-height: 32rem;
  width: 72%;
  margin: 0 0 0 auto;
  transform: translateX(15%) skewX(24deg);
  z-index: 1;
  animation: shadowAnimation 1000ms 200ms ease-in-out forwards;
  @media screen and (max-width: $tab){
    padding: calc(100% / 16 * 7) 0 0;
    min-height: 1rem;
    width: 80%;
  }
  @media screen and (max-width: $phone){
    padding: calc(100% / 16 * 8) 0 0;
    width: 56%;
  }
  @keyframes shadowAnimation {
    0%{
      box-shadow: 0 0 0 rgba($normal,0);
    }
    100%{
      box-shadow: 1.2rem 1.2rem 6.4rem rgba($base,.24);
    }
  }
  img{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    transform: scale(1.1) skewX(-24deg);
    opacity: 0;
    animation: slidePic 1000ms 200ms ease-in-out forwards;
    @media screen and (max-width: $tab){
      width: 120%;
      left: -10%;
    }
    @keyframes slidePic {
      0%{
        opacity: 0;
        transform: translateX(-10%) scale(1.1) skewX(-24deg);
      }
      100%{
        opacity: 1;
        transform: translateX(-10%) scale(1) skewX(-24deg);
      }
    }
  }
}
.title{
  height: 100%;
  position: absolute;
  left: 5%;
  top: 0;
  @include flex();
  align-items: center;
  justify-content: flex-start;
  line-height: 1;
  white-space: nowrap;
  z-index: 2;
  @media screen and (max-width: $tab){
    top: 5%;
  }
  @media screen and (max-width: $phone){
    top: 10%;
  }
  @keyframes slideTitle {
    0%{
      opacity: 0;
      transform: translateY(2rem);
    }
    100%{
      opacity: 1;
      transform: translateY(0);
    }
  }
  h1,p{
    opacity: 0;
    font-weight: 700;
  }
  p{
    letter-spacing: 0;
    font-size: clamp(4.8rem, 12.5vmin, 8rem);
    color: $base;
    animation: slideTitle 800ms 400ms ease-in-out forwards;
    @media screen and (max-width: $tab){
      font-size: 3.2rem;
    }
    @media screen and (max-width: $phone){
      font-size: 1.8rem;
    }
  }
  h1{
    font-size: 2.4vmin;
    text-indent: 1vmin;
    margin: 4.8vmin 0 1.2vmin;
    animation: slideTitle 800ms 200ms ease-in-out forwards;
    @media screen and (max-width: $tab){
      font-size: 1.2rem;
      margin: 0 0 1rem;
      text-indent: 0;
    }
    @media screen and (max-width: $phone){
      font-size: .92rem;
      margin: 0 0 .8rem;
    }
  }
}
.bread{
  position: absolute;
  bottom: 0;
  left: side();
  z-index: 10;
}


</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false
    },
    eng: {
      type: String,
      required: false
    },
    pic: {
      type: String,
      required: false
    },
  }
}
</script>
